import { h, Component, Element, Event, EventEmitter, Prop }
  from '@stencil/core';
import { SelectionFilter } from '../root/selection-filter';


@Component({
  tag: 'tip-table-filter'
})
export class TableFilter {
  @Element() el: HTMLElement;

  @Prop() label: string;
  @Prop() attribute: string;
  @Prop() allOption: string = 'All';
  @Prop({mutable: true}) value: number | string;
  @Prop({mutable: true}) selectionFilter: SelectionFilter;
  @Event() glFilterChanged: EventEmitter;

  changeHandler(e: CustomEvent) {
    e.detail.value === this.allOption ?
      this.value = null : this.value = e.detail.value
    this.selectionFilter = new SelectionFilter({
      category: this.attribute,
      value: this.convertValue(e.detail.value)});
    this.glFilterChanged.emit()
  }

  convertValue(value: any) {
    if (value == 'true') return true;
    if (value == 'false') return false;
    if (!isNaN(value)) return parseInt(value);
    return value;
  }

  render() {
    return (
        <ion-item>
          <ion-select
                value={this.value}
                ok-text="Okay"
                cancel-text="Dismiss"
                label={this.label}
                onIonChange={ (e) => this.changeHandler(e) }>
            <slot />
          </ion-select>
        </ion-item>
    );
  }
}
